<template>
  <div
    class="modal fade"
    id="editCaseModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editCaseModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-if="show">
        <div class="modal-header shadow-sm">
          <h6 class="modal-title font-weight-bold" id="editCaseModalLabel">
            <!-- <font-awesome-icon
              :icon="getCaseIcon(currentCase.type).i"
              class="media-icon mr-2"
              :class="`text-${getCaseIcon(currentCase.type).color}`"
            /> -->
            <!-- <template v-if="currentCase">
              <small class="d-block line-height-1 text-muted"
                >Case Number</small
              >
              {{ currentCase.caseNumber }}
            </template>
            <template v-else> Add new case </template> -->
            <template> Edit case </template>
          </h6>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small" for="latitude">Latitude</label>
                <input
                  type="number"
                  step="any"
                  min="0"
                  class="form-control form-control-default form-control-sm"
                  id="latitude"
                  v-model="models.lat"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small" for="longitude">Longitude</label>
                <input
                  type="number"
                  step="any"
                  min="0"
                  class="form-control form-control-default form-control-sm"
                  id="longitude"
                  v-model="models.lng"
                />
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small" for="section">No. Seksyen</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  class="form-control form-control-default form-control-sm"
                  id="section"
                  v-model="models.section"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small" for="timestamp">
                  Tarikh &amp; Waktu<sup class="text-danger">*</sup>
                </label>
                <p
                  class="
                    form-control form-control-default form-control-sm
                    d-flex
                    justify-content-between
                    align-items-center
                    clickable
                  "
                  @click="showDateSelector = true"
                >
                  <span>{{ formatDate(models.timestamp) }}</span>
                  <font-awesome-icon :icon="['far', 'calendar-alt']" />
                </p>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <label class="small" for="reportType">
                  Skop Kerja<sup class="text-danger">*</sup>
                </label>
                <select
                  id="reportType"
                  class="custom-select custom-select-sm"
                  v-model="models.reportType"
                >
                  <option :value="null" disabled>-- Select work scope</option>
                  <option
                    v-for="scope in workScopes"
                    :key="`scope-${scope}`"
                    :value="scope"
                  >
                    {{ scope }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small"> Kategori </label>
                </div>
                <select
                  class="custom-select custom-select-sm"
                  v-model="models.category"
                >
                  <option :value="null" disabled>-- Pilih Kategori</option>
                  <option
                    v-for="category in categories"
                    :key="category"
                    :value="category"
                  >
                    {{ category.split("_").join(" ") }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small">
                    Daerah<sup class="text-danger">*</sup>
                  </label>
                </div>
                <select
                  class="custom-select custom-select-sm"
                  v-model="models.district"
                >
                  <option :value="null" disabled>-- Pilih Daerah</option>
                  <option
                    v-for="district in districts"
                    :key="district._id"
                    :value="district._id"
                  >
                    {{ district.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small">
                    No. &amp; Nama Laluan<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="
                      btn btn-sm
                      border
                      btn-block
                      dropdown-toggle
                      position-relative
                      d-flex
                      justify-content-between
                      align-items-center
                      px-3
                    "
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownRoadButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span v-if="roads.find((road) => road._id == models.road)">
                      {{ roads.find((road) => road._id == models.road).name }}
                    </span>
                    <span v-else class="text-muted">-- Pilih No. &amp; Name Laluan</span>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow"
                    aria-labelledby="dropdownRoadButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                    <input
                      class="
                        form-control form-control-sm
                        border-left-0 border-top-0 border-right-0
                      "
                      placeholder="Search"
                      v-model="searchModel"
                    />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button
                        v-for="road in roadList"
                        :key="road._id"
                        class="
                          border-bottom
                          dropdown-item
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                        :class="{
                          'bg-subtle': models.road && models.road == road._id,
                        }"
                        style="color: #495057"
                        @click="models.road = road._id"
                      >
                        <span>
                          {{ road.name }}
                          <font-awesome-icon
                            :icon="['fas', 'check']"
                            class="text-primary ml-2 small"
                            v-if="models.road && models.road == road._id"
                          />
                        </span>
                        <span class="small text-muted text-capitalize ml-3"
                          >({{ road.type }})</span
                        >
                      </button>
                      <div
                        class="
                          dropdown-item
                          py-2
                          small
                          text-center text-muted
                          font-italic
                        "
                      >
                        <span v-if="roadList.length > 0">End of list</span>
                        <span v-else>No road found</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small">Kerosakan Dikenalpasti</label>
                </div>
                <textarea
                  v-model="models.caption"
                  rows="10"
                  class="form-control form-control-default form-control-sm"
                  style="resize: none"
                />
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small">Catatan</label>
                </div>
                <textarea
                  v-model="models.remarks"
                  rows="5"
                  class="form-control form-control-default form-control-sm"
                  style="resize: none"
                />
              </div>
            </div>
          </div>
          <!-- <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small"> Contractor </label>
                </div>
                <select
                  class="custom-select custom-select-sm"
                  v-model="models.contractor"
                >
                  <option :value="null" disabled>-- Select contractor</option>
                  <option
                    v-for="contractor in contractors"
                    :key="contractor._id"
                    :value="contractor._id"
                  >
                    {{ contractor.name }}
                  </option>
                </select>
              </div>
            </div>
          </div> -->
        </div>
        <div class="modal-footer shadow">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-custom"
            @click="saveChanges()"
            :disabled="isProcessing"
          >
            <div
              class="spinner-border spinner-border-sm text-light"
              v-if="isProcessing"
            ></div>
            <span v-else> Save </span>
          </button>
        </div>
      </div>
    </div>
    <date-time-selector
      v-if="showDateSelector"
      :date="currentCase ? models.timestamp : Date.now()"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Helper from "@/helper";
import Swal from "sweetalert2";
import DateTimeSelector from "@/components/DateTimeSelector";

export default {
  name: "edit-case-modal",
  props: ["show", "currentCase", "districts", "roads", "contractors"],
  components: {
    DateTimeSelector,
  },
  data() {
    return {
      isProcessing: false,
      showDateSelector: false,
      searchModel: "",
      // workScopes: ["R01", "R02", "R03", "R04", "R05", "R06", "R07", "R011", "RI"],
      workScopes: ["R01", "RI"],
      categories: Helper.workCategories(),
      models: {
        lat: null,
        lng: null,
        section: null,
        road: null,
        district: null,
        caption: null,
        timestamp: null,
        reportType: null,
        category: null,
        remarks: null,
      },
      emptyModels: {
        lat: null,
        lng: null,
        section: null,
        road: null,
        district: null,
        caption: null,
        timestamp: null,
        reportType: null,
        category: null,
        remarks: null,
      },
    };
  },
  watch: {
    show: {
      async handler() {
        if (this.show) {
          $("#editCaseModal").modal("show");

          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          if (this.currentCase) {
            this.models.lat = this.currentCase.lat;
            this.models.lng = this.currentCase.lng;
            this.models.section = this.currentCase.section;
            this.models.caption = this.currentCase.caption;
            this.models.remarks = this.currentCase.remarks;
            this.models.timestamp = this.currentCase.timestamp;
            this.models.reportType = this.currentCase.reportType;
            this.models.category = this.currentCase.category;
            this.models.district = this.currentCase.district
              ? this.currentCase.district._id
              : null;
            this.models.road = this.currentCase.road
              ? this.currentCase.road._id
              : null;
          }

          const _user = localStorage.getItem("user");

          if (_user && JSON.parse(_user).contractor) {
            this.models.contractor = JSON.parse(_user).contractor._id;
          } else {
            this.models.contractor = null;
          }
        } else {
          $("#editCaseModal").modal("hide");
        }
      },
      immediate: true,
    },
    "models.district": {
      handler() {
        const selectedRoad = this.roads
          .filter((road) => road.daerah == this.models.district)
          .find((road) => road._id == this.models.road);

        if (!selectedRoad) {
          this.models.road = "";
        }
      },
      deep: true,
      immediate: true,
    },
    "models.road": {
      handler() {
        this.searchModel = "";
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    roadList() {
      let list = JSON.parse(
        JSON.stringify(
          this.roads.filter((road) => road.daerah == this.models.district)
        )
      );

      if (this.models.road) {
        const selectedRoad = list.find((l) => l._id == this.models.road);

        if (selectedRoad) {
          list = list.filter((l) => l._id != selectedRoad._id);

          list.unshift(selectedRoad);
        }
      }

      if (this.searchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.searchModel.toLowerCase())
        );
      }

      return list;
    },
  },
  methods: {
    dateSelected(e) {
      if (e) {
        this.models.timestamp = e;
      }

      this.showDateSelector = false;
    },
    formatDate(timestamp) {
      return Helper.formatDate(timestamp);
    },
    getCaseIcon(type) {
      return Helper.socialMediaIcons(type);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
    saveChanges() {
      this.isProcessing = true;

      if (this.models.lat == "" || this.models.lat == "0") {
        this.models.lat = null;
      }

      if (this.models.lng == "" || this.models.lng == "0") {
        this.models.lng = null;
      }

      if (this.models.section == "" || this.models.section == "0") {
        this.models.section = null;
      }

      if (!this.models.timestamp) {
        this.isProcessing = false;

        return Swal.fire("Invalid date / time", "", "error");
      }

      if (!this.models.reportType) {
        this.isProcessing = false;

        return Swal.fire("Please select work scope", "", "error");
      }

      if (!this.models.district || !this.models.road) {
        this.isProcessing = false;

        return Swal.fire("Invalid district / road", "", "error");
      }

      if (this.currentCase) {
        API.put(`cases/${this.currentCase._id}`, this.models)
          .then((retVal) => {
            this.isProcessing = false;

            this.closeModal(retVal.data);
          })
          .catch((err) => {
            this.isProcessing = false;

            console.error(err);
          });
      } else {
        let body = JSON.parse(JSON.stringify(this.models));

        body.source = "agent";
        body.type = "mobile";
        body.status = "received";

        API.post("cases", body)
          .then((retVal) => {
            this.isProcessing = false;

            this.closeModal(retVal.data);
          })
          .catch((err) => {
            this.isProcessing = false;

            console.error(err);
          });
      }
    },
  },
};
</script>